import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFadeInOnScroll } from '../../../hooks/useFadeInOnScroll';
import { Container, SectionHeader, EnhancedSectionTitle, SectionSubtitle } from '../../styles/sharedComponents';
import FAQItem from './FAQItem';
import FAQPreview from './FAQPreview';
import { FAQWrapper, FAQGrid, FAQList, FAQDetail, FAQDetailCard } from './styles';

type FAQItemType = { q: string; a: string };

const FAQ: React.FC = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number>(0);
  const [faqRef, faqVisible] = useFadeInOnScroll<HTMLElement>();

  const faqKeys = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'q8', 'q9', 'q10'];
  const faqs: FAQItemType[] = faqKeys.map(key => ({
    q: t(`faq.items.${key}.question`),
    a: t(`faq.items.${key}.answer`)
  }));

  return (
    <FAQWrapper ref={faqRef} $isVisible={faqVisible} id="faq">
      <Container>
        <SectionHeader>
          <EnhancedSectionTitle>{t('faq.title')}</EnhancedSectionTitle>
          <SectionSubtitle>
            {t('faq.subtitle')}
          </SectionSubtitle>
        </SectionHeader>

        <FAQGrid>
          <FAQList role="tablist" aria-label={t('faq.title')}>
            {faqs.map((item, idx) => (
              <FAQItem
                key={idx}
                index={idx}
                question={item.q}
                isActive={openIndex === idx}
                onClick={() => setOpenIndex(idx)}
              />
            ))}
          </FAQList>

          <FAQDetail>
            <FAQDetailCard data-active={true}>
              <FAQPreview
                activeIndex={openIndex}
                faqKeys={faqKeys}
              />
            </FAQDetailCard>
          </FAQDetail>
        </FAQGrid>
      </Container>
    </FAQWrapper>
  );
};

export default FAQ;
